module.exports = __webpack_public_path__ + "static/media/hardwareRepair-headline.641e8d18.png";